import LoginConstants from '../../constants/Login/LoginConstants.js';
import departments, { DEFAULT_STATE as DEPARTMENTS_DEFAULT_STATE } from './Departments/departments.js';
import teams, { DEFAULT_STATE as TEAMS_DEFAULT_STATE } from './Teams/teams.js';

const DEFAULT_STATE = {
    departments: DEPARTMENTS_DEFAULT_STATE,
    teams: TEAMS_DEFAULT_STATE,
};

export default function adminReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case LoginConstants.LOGOUT: // reset all stores on logout
            return DEFAULT_STATE;

        case 'AdminDepartmentActions.ON_GETALL':
        case 'AdminDepartmentActions.ON_GETALLBYCAMPUS':
        case 'AdminDepartmentActions.ON_CREATE':
        case 'AdminDepartmentActions.ON_DELETE':
        case 'AdminDepartmentActions.ON_RESET':
            return {
                ...state,
                departments: departments(state.departments, action),
            };

        case 'AdminTeamActions.ON_ADDMEMBERS':
        case 'AdminTeamActions.ON_CREATE':
        case 'AdminTeamActions.ON_DELETE':
        case 'AdminTeamActions.ON_GETALL':
        case 'AdminTeamActions.ON_GETALLBYCAMPUS':
        case 'AdminTeamActions.ON_GETMEMBERS':
        case 'AdminTeamActions.ON_GETMEMBERSNEXTPAGE':
        case 'AdminTeamActions.ON_REMOVEMEMBERS':
        case 'AdminTeamActions.ON_RESET':
        case 'AdminTeamActions.ON_UPDATE':
            return {
                ...state,
                teams: teams(state.teams, action),
            };

        default:
            return state;
    }
}
